import { FeedbackStatus, FeedbackType } from "../../../types/feedback";
import {
  useAddFeedbackMutation,
  useAddFeedbackSkillMutation,
} from "../../../graphql/__generated__/hooks";
import { useAppDispatch } from "../../../hooks/useAppDispatch";
import { sendAlertViaEmail } from "../../../reduxStore/alert/thunks";
import { ALERT_TYPES } from "../../../helpers/constants";
import { useNavigate } from "react-router-dom";
import { useAuthUser } from "../../../hooks/useAuthUser";

export const useRequestFeedbackUtils = () => {
  const [addFeedback] = useAddFeedbackMutation();
  const [addFeedbackSkill] = useAddFeedbackSkillMutation();
  const dispatchRedux = useAppDispatch();
  const navigate = useNavigate();
  const { user } = useAuthUser();

  const handleRetryFeedbackRequest = async (feedback: FeedbackType) => {
    const feedbackData = Object.assign({}, feedback);
    feedbackData.status = FeedbackStatus.DRAFT;
    feedbackData.reviewed_at = undefined;
    feedbackData.observation_date = new Date().toISOString();

    const response = await addFeedback({
      variables: feedbackData,
    });

    await addFeedbackSkill({
      variables: {
        feedback_id: response.data?.insert_feedback?.returning[0].feedback_id,
        requirement_id:
          feedbackData.feedback_skills[0].requirement.requirement_id,
      },
    });
    dispatchRedux(
      sendAlertViaEmail({
        feedbackId:
          response.data?.insert_feedback?.returning[0].feedback_id || "",
        coachName: feedbackData?.coach?.name || "",
        coachEmail: feedbackData?.coach?.email || "",
        coachId: feedbackData?.coach?.user_id || feedbackData?.coach_id || "",
        studentName: user?.name || "",
        type: ALERT_TYPES.FEEDBACK_REQUEST,
      }),
    );
    navigate(
      `/request-feedback/${response.data?.insert_feedback?.returning[0].feedback_id}`,
    );
  };

  return { handleRetryFeedbackRequest };
};
